import {
  Box,
  Center,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import StructuredTextParserRemake from '@components/Utility/ArticleParser/StructuredTextParserRemake';
import { render } from 'datocms-structured-text-to-html-string';
import { useRef } from 'react';

export const RemarketModal = ({
  divider,
  width = '1170px',
  height = '600px',
  isOpen,
  onClose,
  modalData,
}) => {
  return (
    <Modal
      maxW={width}
      minHeight={height}
      isOpen={isOpen}
      onClose={onClose}
      background="#fff"
      isCentered={true}
    >
      <ModalOverlay />
      <ModalContent
        borderRadius="0px"
        bgImg={'https://static.sadhguru.org/d/46272/1733684101-81185-right.png'}
        bgColor="#fff"
        bgPos="-10px -10px"
        bgRepeat="no-repeat"
        bgSize="50%"
        maxW={{ base: '100%', md: '746px', lg: '808px', xl: width }}
        h={{ base: '100%', md: height }}
        pt={{ md: '59px' }}
        pl={{ md: '81px' }}
        pr={{ md: '74px' }}
        pb={{ md: '48px' }}
      >
        {modalData?.title && (
          <ModalHeader p="0px" width="95%" mb={!divider ? '10px' : '0px'}>
            <Text
              fontSize={{ base: '1.375rem', md: '2rem' }}
              lineHeight={{ base: '1.87rem', md: '2.78rem' }}
              fontFamily="FedraSansStd-book"
              color="#11146E"
            >
              {modalData?.title}
            </Text>
            {divider && (
              <Divider
                orientation="horizontal"
                borderWidth="2px"
                borderColor="#E9DEC7"
                borderStyle="solid"
                mt="1.625rem"
                mb="1.5rem"
              />
            )}
          </ModalHeader>
        )}
        <ModalCloseButton
          color="#F37021"
          top={{ md: '11%' }}
          right={{ md: '8%', xl: '5%' }}
          background="transparent"
          _hover={{
            background: 'transparent',
            boxShadow: 'none',
          }}
          _active={{
            background: 'transparent',
            boxShadow: 'none',
          }}
          _focus={{
            background: 'transparent',
            boxShadow: 'none',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19 20.4143L12 13.4143L4.99997 20.4143L3.58576 19.0001L10.5858 12.0001L3.58576 5.00009L4.99997 3.58588L12 10.5859L19 3.58588L20.4142 5.00009L13.4142 12.0001L20.4142 19.0001L19 20.4143Z"
              fill="#F37021"
            />
          </svg>
        </ModalCloseButton>
        <ModalBody p="0" m="0">
          <Box
            fontFamily="FedraSansStd-book"
            overflowY="auto"
            className="modal-customScrollbar"
            pr={{ md: '5px' }}
          >
            {modalData?.description && (
              <StructuredTextParserRemake
                str={render(modalData?.description)}
                isOpen={isOpen}
                fontSize={{ base: '1rem', md: '1.125rem' }}
                lineHeight={{ base: '1.75rem', md: '2rem' }}
                fontFamily="FedraSansStd-book"
                maxW={'1005px !important'}
                width="100%"
                mx="auto"
                overflowY="auto"
                mt="0px"
              />
            )}
          </Box>
        </ModalBody>
      </ModalContent>
      <style>{`
        .modal-customScrollbar {
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow-y: auto;
          text-overflow: ellipsis;
          height: 380px;
        }
        .modal-customScrollbar::-webkit-scrollbar {
          width: 6px;
        }

        /* Track */
        .modal-customScrollbar::-webkit-scrollbar-track {
          background:white;
          border:none;
          width: 12px;
          background: #F6F2EA;
        }
          
        /* Handle */
        .modal-customScrollbar::-webkit-scrollbar-thumb {
          width: 9.6px;
          margin: 0 1px 0 auto;
          height: 14.4px;
          background: #F37021;
        }

        /* Handle on hover */
        .modal-customScrollbar::-webkit-scrollbar-thumb:hover {
          #background: #F37021; 
        }
      `}</style>
    </Modal>
  );
};

export const RemarketDrawer = ({ divider, isOpen, onClose, modalData }) => {
  return (
    <Drawer
      isOpen={isOpen}
      placement="bottom"
      onClose={onClose}
      // finalFocusRef={storiRef}
      bgImg={'https://static.sadhguru.org/d/46272/1733684101-81185-right.png'}
      bgColor="#fff"
      bgPos="0px 0px"
      bgRepeat="no-repeat"
      bgSize="50%"
    >
      <DrawerOverlay bg="blackAlpha.500" />
      <DrawerContent bg="#fff" position="relative" borderRadius="lg">
        {modalData?.title && (
          <DrawerHeader p="16px 8px 8px 16px" width="95%">
            <Text
              fontSize={{ base: '1.375rem', md: '2rem' }}
              lineHeight={{ base: '1.87rem', md: '2.78rem' }}
              fontFamily="FedraSansStd-book"
              color="#11146E"
              maxW={'1005px !important'}
              width={{ base: '90%', md: '85%' }}
              fontWeight={600}
            >
              {modalData?.title}
            </Text>
            {divider && (
              <Divider
                orientation="horizontal"
                width="100%"
                borderWidth="2px"
                borderColor="#E9DEC7"
                borderStyle="solid"
                mt="1.625rem"
                mb={!divider ? '1.625rem' : '0rem'}
              />
            )}
          </DrawerHeader>
        )}
        <DrawerCloseButton>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_16048_19889)">
              <path
                d="M2 2L14.25 14.25M14.25 2L2 14.25"
                stroke="#F37021"
                stroke-width="1.75"
                stroke-linecap="square"
              />
            </g>
            <defs>
              <clipPath id="clip0_16048_19889">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </DrawerCloseButton>
        <DrawerBody p="8px 18px">
          <Box
            width="100%"
            fontFamily="FedraSansStd-book"
            overflowY="auto"
            className="customScrollbar_about"
            pr={'5px'}
          >
            <StructuredTextParserRemake
              str={render(modalData?.description)}
              isOpen={isOpen}
              fontSize={{ base: '1rem', md: '1.125rem' }}
              lineHeight={{ base: '1.75rem', md: '2rem' }}
              fontFamily="FedraSansStd-book"
              maxW={'1005px !important'}
              width="100%"
              mx="auto"
            />
          </Box>
        </DrawerBody>
      </DrawerContent>
      <style>
        {`
        .customScrollbar_about {
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow-y: auto;
          text-overflow: ellipsis;
          height: calc(70vh - 7vh);
        }
        .customScrollbar_about::-webkit-scrollbar {
          width: 6px;
        }

        /* Track */
        .customScrollbar_about::-webkit-scrollbar-track {
          background:white;
          border:none;
          width: 12px;
          background: #F6F2EA;
        }
          
        /* Handle */
        .customScrollbar_about::-webkit-scrollbar-thumb {
          width: 9.6px;
          margin: 0 1px 0 auto;
          height: 14.4px;
          background: #F37021;
        }

        /* Handle on hover */
        .customScrollbar_about::-webkit-scrollbar-thumb:hover {
          #background: #F37021; 
        }
      `}
      </style>
    </Drawer>
  );
};

export const RemarketStorieModal = ({ lang, isOpen, onClose, modalData }) => {
  const storiRef = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={true}
      dir={lang === 'ar' ? 'rtl' : 'ltr'}
      finalFocusRef={storiRef}
    >
      <ModalOverlay bg="blackAlpha.800" />
      <ModalContent
        background="none"
        my={{ base: '0', md: '0', lg: '3.75rem' }}
        border="none"
        boxShadow="none"
      >
        <ModalCloseButton
          color="#F37021"
          zIndex="1"
          mt="5px"
          background="transparent"
          _hover={{
            background: 'transparent',
            boxShadow: 'none',
          }}
          _active={{
            background: 'transparent',
            boxShadow: 'none',
          }}
          _focus={{
            background: 'transparent',
            boxShadow: 'none',
          }}
          top={{ base: '4%', md: '2%' }}
          right={{ base: '6%', md: '14%' }}
        >
          <Box>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_16048_19889)">
                <path
                  d="M2 2L14.25 14.25M14.25 2L2 14.25"
                  stroke="#F37021"
                  stroke-width="1.75"
                  stroke-linecap="square"
                />
              </g>
              <defs>
                <clipPath id="clip0_16048_19889">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Box>
        </ModalCloseButton>
        <ModalBody p="0px">
          <Center>
            <Box
              width={{
                base: '320px !important',
                md: '366px !important',
              }}
              pt={{ base: '30px', md: '10px' }}
              px={{ base: '16px' }}
            >
              <Box
                position="relative"
                display="flex"
                gridGap="30px"
                minHeight="580px"
              >
                <Box overflow="hidden" boxShadow="lg" bg="#fff">
                  {modalData?.photo.url && (
                    <Image
                      src={modalData?.photo.url}
                      alt="Profile picture of a person standing outdoors"
                      w="full"
                      h="250px"
                    />
                  )}
                  <Box p={{ base: '0.5rem 1.375rem 1.125rem' }}>
                    <Box
                      display="flex"
                      flexDir="column"
                      alignItems="center"
                      mb={{ base: '1.125rem' }}
                      fontFamily="FedraSansStd-medium"
                    >
                      <StructuredTextParser
                        mt="0px"
                        pr="5px"
                        maxWidth="auto"
                        str={render(modalData?.userDescription)}
                        color="#6D6358"
                        fontSize="1.5rem"
                        lineHeight="2.25rem"
                      />
                      <StructuredTextParser
                        mt="0px"
                        pr="5px"
                        maxWidth="auto"
                        str={render(modalData?.additionalDetails)}
                        color="#12166F"
                        fontSize="1.125rem"
                        lineHeight="1.418rem"
                        fontFamily="FedraSansStd-book"
                        textAlign="center"
                        fontWeight={450}
                      />
                    </Box>
                    <Box
                      fontFamily="FedraSansStd-book"
                      overflowY="auto"
                      className="customScrollbar-modal"
                      pr="10px"
                    >
                      <StructuredTextParser
                        fontSize={{
                          base: '1rem',
                          lg: '1.125rem',
                        }}
                        lineHeight={{
                          base: '1.5rem',
                          md: '1.688rem',
                        }}
                        color="#6D6358"
                        str={render(modalData?.testimonialText)}
                        mt="0px"
                        fontStyle="italic"
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Center>
        </ModalBody>
      </ModalContent>
      <style>{`
        .customScrollbar-modal {
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow-y: auto;
          text-overflow: ellipsis;
          height: 220px;
        }
        .customScrollbar-modal::-webkit-scrollbar {
          width: 6px;
        }

        /* Track */
        .customScrollbar-modal::-webkit-scrollbar-track {
          background:white;
          border:none;
          width: 12px;
          background: #F6F2EA;
        }
          
        /* Handle */
        .customScrollbar-modal::-webkit-scrollbar-thumb {
          width: 9.6px;
          margin: 0 1px 0 auto;
          height: 14.4px;
          background: #F37021;
        }

        /* Handle on hover */
        .customScrollbar-modal::-webkit-scrollbar-thumb:hover {
          #background: #F37021; 
        }
      `}</style>
    </Modal>
  );
};

export const RemarketMobileDrawer = ({
  header,
  imgWidth,
  isOpen,
  onClose,
  modalData,
}) => {
  const storiRef = useRef(null);

  return (
    <Drawer
      isOpen={isOpen}
      placement="bottom"
      onClose={onClose}
      finalFocusRef={storiRef}
    >
      <DrawerOverlay bg="blackAlpha.900" />
      <DrawerContent
        bg="#fff"
        position="relative"
        borderRadius="lg"
        height="80%"
      >
        <DrawerCloseButton>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_16048_19889)">
              <path
                d="M2 2L14.25 14.25M14.25 2L2 14.25"
                stroke="#F37021"
                stroke-width="1.75"
                stroke-linecap="square"
              />
            </g>
            <defs>
              <clipPath id="clip0_16048_19889">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </DrawerCloseButton>
        <DrawerBody p="18px">
          {modalData?.photo.url && (
            <Box position="absolute" top="-90px">
              <Image
                src={modalData?.photo.url}
                alt="Profile picture of a person standing outdoors"
                objectFit="cover"
                w={imgWidth}
                h="165px"
              />
            </Box>
          )}

          <Box mt="75px" overflowY="auto" className="scroll-drawer" pr="5px">
            <Box
              display="flex"
              flexDir="column"
              alignItems="center"
              fontFamily="FedraSansStd-medium"
            >
              <Text
                fontSize={{
                  base: '1.125rem',
                  md: '1.375rem',
                }}
                lineHeight={{
                  base: '1.688rem',
                  md: '2.063rem',
                }}
                color="#433F3C"
              >
                {modalData?.userName}
              </Text>
              {header && (
                <>
                  <StructuredTextParser
                    mt="0px"
                    pr="5px"
                    maxWidth="auto"
                    str={render(modalData?.userDescription)}
                    color="#6D6358"
                    fontSize="1.5rem"
                    lineHeight="2.25rem"
                    textAlign="center"
                  />
                  <StructuredTextParser
                    mt="0px"
                    pr="5px"
                    maxWidth="auto"
                    str={render(modalData?.additionalDetails)}
                    color="#12166F"
                    fontSize="1rem"
                    lineHeight="1.688rem"
                    textAlign="center"
                    fontFamily="FedraSansStd-book"
                    fontWeight={450}
                  />
                </>
              )}
            </Box>

            <StructuredTextParser
              fontFamily="FedraSansStd-book"
              fontSize={{
                base: '1rem',
                md: '1.125rem',
              }}
              lineHeight={{
                base: '1.5rem',
                md: '1.688rem',
              }}
              color="#6D6358"
              str={render(modalData?.testimonialText)}
              mx="0px"
              maxW="100%"
              className="stories-transformation-drawer"
              fontStyle="italic"
            />
          </Box>
        </DrawerBody>
      </DrawerContent>
      <style>{`
        .scroll-drawer {
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow-y: auto;
          text-overflow: ellipsis;
          height: calc(70vh - 4vh);
        }
        .scroll-drawer::-webkit-scrollbar {
          width: 6px;
        }

        /* Track */
        .scroll-drawer::-webkit-scrollbar-track {
          background:white;
          border:none;
          width: 12px;
          background: #F6F2EA;
        }
          
        /* Handle */
        .scroll-drawer::-webkit-scrollbar-thumb {
          width: 9.6px;
          margin: 0 1px 0 auto;
          height: 14.4px;
          background: #F37021;
        }

        /* Handle on hover */
        .customScrollbar-modal::-webkit-scrollbar-thumb:hover {
          #background: #F37021; 
        }

        .stories-transformation-drawer p strong{
          color: #000
        }
      `}</style>
    </Drawer>
  );
};
